import React from 'react'

import { bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Header({ isSignup }) {
  const t = useTranslation()

  return (
    <div className="ai-sign-in-modal__header-group">
      <p className="ai-sign-in-modal__title cgt-heading-300">
        {isSignup ? t('signIn.header.signupTitle') : t('signIn.header.loginTitle')}
      </p>
      <p className="ai-sign-in-modal__subtitle cgt-body-md">
        {isSignup ? t('signIn.header.signupSubtitle') : t('signIn.header.loginSubtitle')}
      </p>
    </div>
  )
}

Header.propTypes = {
  isSignup: bool.isRequired,
}

export default Header
